import styled from 'styled-components'

export const WebinarFormIntro = styled.div`
  background: #e1eaff;
  padding: 25px 30px;
  border-radius: 5px;
  margin: 25px 0;

  .WebinarFormIntro {
    color: #131d40;
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
  }
`

export const WebinarSpeakersTitle = styled.div`
  margin-bottom: 24px;
  font-size: 22px;
  font-weight: 550;
`

export const WebinarFinePrint = styled.div`
  margin-top: 20px;

  * {
    font-size: 12px;
    margin: 0;
  }

  p {
    margin: 0;
  }
`
export const RobotReleaseContainer = styled.div`
  width: 200px;
  position: absolute;
  height: 140px;
  right: -65px;
  top: -50px;
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 160px;
    height: 112px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    top: -25px;
  }

  .RobotRelease__Img-File {
    width: 100%;
    height: auto;
    min-height: 100%;
    object-fit: cover;
    transform: rotate(6deg);
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    left: 210px;
    right: unset;
  }

  @media (max-width: 480px) {
    left: 160px;
  }
`
